export default "__VITE_ASSET__Bw$ajX5Q__"